// extracted by mini-css-extract-plugin
export default {"colStyle":"bouncedcheques_colStyle__7+iRd","colHead":"bouncedcheques_colHead__NvqqV"};